/*!
 * Rede i-tal — CEP → Tier de Distância
 *
 * Quando o cliente digita o CEP (cart shipping calculator, drawer, etc.), faz
 * lookup no Cloudflare Worker (rdt-shipping.redeital.workers.dev/lookup?cep=)
 * e seta cart attributes que a Shopify Function lê pra filtrar tarifas.
 *
 * Cart attributes setados:
 *   _rdt_tier        → "1" | "2" | "3" (distância da origem Bangu)
 *   _rdt_zone_id     → número da zona (1..29)
 *   _rdt_zone_name   → nome da zona ("Tijuca...")
 *
 * Carregar no theme.liquid:
 *   <script src="{{ 'rdt-cep-tier.js' | asset_url }}" defer></script>
 */
(function() {
  'use strict';

  var WORKER_LOOKUP = 'https://rdt-shipping.redeital.workers.dev/lookup';
  var DEBOUNCE_MS = 600;
  var CEP_RE = /\d{8}/;

  // Seletores comuns de inputs de CEP em temas Shopify (Vegist + outros)
  var CEP_SELECTORS = [
    'input[name="address[zip]"]',
    'input[name="zip"]',
    'input[name="postal_code"]',
    'input[id*="zip" i]',
    'input[id*="cep" i]',
    'input[id*="postal" i]',
    'input[name*="zip" i]',
    'input[name*="cep" i]',
    'input[data-address-zip]',
  ].join(',');

  var debounceTimer = null;
  var lastCep = null;

  function normalizeCep(raw) {
    if (!raw) return null;
    var digits = String(raw).replace(/\D/g, '');
    return CEP_RE.test(digits) ? digits.slice(0, 8) : null;
  }

  function looksLikeCepInput(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    var t = (el.type || 'text').toLowerCase();
    if (t !== 'text' && t !== 'tel' && t !== 'number' && t !== 'search') return false;
    return true;
  }

  function lookup(cep) {
    return fetch(WORKER_LOOKUP + '?cep=' + cep, { credentials: 'omit' })
      .then(function(r) { return r.json(); })
      .catch(function() { return null; });
  }

  function setCartAttributes(data) {
    // SEMPRE inclui _rdt_now_iso pra Function poder filtrar Cat B por janela
    // (Shopify Functions runtime tem Date.now() determinístico → não dá pra ler do runtime)
    var attrs = {
      '_rdt_now_iso': new Date().toISOString(),
    };
    try {
      var cat = (localStorage.getItem('rdt_catalog') || '').toUpperCase();
      if (cat === 'A' || cat === 'B') attrs['_rdt_catalog'] = cat;
    } catch (e) {}
    if (data && data.tier) attrs['_rdt_tier'] = String(data.tier);
    if (data && data.zone_id) attrs['_rdt_zone_id'] = String(data.zone_id);
    if (data && data.zone_name) attrs['_rdt_zone_name'] = data.zone_name;

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      credentials: 'same-origin',
    }).then(function(r) { return r.json(); }).catch(function() { return null; });
  }

  // Refresh do _rdt_now_iso a cada cart/checkout load — sem isso a Function não consegue
  // filtrar por janela de horário e Cat B fica sempre escondida (modo conservador).
  function refreshNowAttribute() {
    setCartAttributes(null);
  }

  function handleCepInput(value) {
    var cep = normalizeCep(value);
    if (!cep || cep === lastCep) return;
    lastCep = cep;

    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function() {
      lookup(cep).then(function(data) {
        if (!data) return;
        // Mesmo se tier=null (fora de zona) seta zona null pra Function poder
        // distinguir "CEP fornecido mas fora" vs "CEP não fornecido ainda"
        return setCartAttributes(data);
      });
    }, DEBOUNCE_MS);
  }

  // Listener global em inputs digitados
  document.addEventListener('input', function(e) {
    var el = e.target;
    if (!looksLikeCepInput(el)) return;
    if (!el.matches(CEP_SELECTORS)) return;
    handleCepInput(el.value);
  }, true);

  // Também dispara no blur (alguns temas só validam ao sair do campo)
  document.addEventListener('blur', function(e) {
    var el = e.target;
    if (!looksLikeCepInput(el)) return;
    if (!el.matches(CEP_SELECTORS)) return;
    handleCepInput(el.value);
  }, true);

  // ─── Popup Cat B fora da janela ──────────────────────────────────────
  // Quando o carrinho é puro Cat B e nenhuma das janelas (Mesmo Dia / Expressa) está aberta,
  // mostra modal explicando + oferecendo Agendada ou voltar mais tarde.
  var POPUP_KEY = 'rdt_catb_popup_dismissed';

  function getCartCatalog() {
    try {
      var ls = (localStorage.getItem('rdt_catalog') || '').toUpperCase();
      if (ls === 'A' || ls === 'B') return ls;
    } catch(e){}
    return null;
  }

  function checkCatBWindowAndPopup() {
    var catalog = getCartCatalog();
    if (catalog !== 'B') return;
    // Não rerepete se já dispensou na sessão (até refresh ou trocar de catálogo)
    try { if (sessionStorage.getItem(POPUP_KEY)) return; } catch(e){}

    // Usa o cache do último lookup OU faz uma chamada genérica
    var lastData = window.__rdtLastLookup;
    if (lastData) return showCatBPopupIfNeeded(lastData);
    // Faz um lookup com CEP "vazio" só pra pegar status temporal
    fetch(WORKER_LOOKUP + '?cep=00000000', { credentials: 'omit' })
      .then(function(r) { return r.json(); })
      .then(function(d) {
        // Mesmo com CEP inválido o Worker retorna sunday + dateLabel e cat_b status agora
        if (!d) return;
        if (d.cat_b) showCatBPopupIfNeeded(d);
      })
      .catch(function(){});
  }

  function showCatBPopupIfNeeded(data) {
    var status = data.cat_b;
    if (!status) return;
    if (status.mesmo_dia.open || status.expressa.open) return;  // alguma janela aberta → não mostra
    if (document.getElementById('rdt-catb-popup')) return;  // já tá aberto

    var mdNext = status.mesmo_dia.next_open ? status.mesmo_dia.next_open.label : '—';
    var exNext = status.expressa.next_open ? status.expressa.next_open.label : '—';
    var nextDelivery = data.next_delivery_label || '—';

    var overlay = document.createElement('div');
    overlay.id = 'rdt-catb-popup';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(28,25,23,0.55);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;animation:rdtFade .15s ease-out;';
    overlay.innerHTML = ''
      + '<style>@keyframes rdtFade{from{opacity:0}to{opacity:1}}@keyframes rdtSlide{from{transform:translateY(12px);opacity:0}to{transform:translateY(0);opacity:1}}</style>'
      + '<div role="dialog" aria-modal="true" style="background:#fff;border-radius:14px;max-width:440px;width:100%;padding:24px 22px;box-shadow:0 24px 48px rgba(0,0,0,.2);font-family:system-ui,-apple-system,sans-serif;animation:rdtSlide .18s ease-out;color:#1c1917">'
      +   '<div style="display:flex;align-items:flex-start;gap:12px;margin-bottom:14px">'
      +     '<div style="width:36px;height:36px;border-radius:8px;background:#FEF3C7;color:#92400E;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0">⏰</div>'
      +     '<div><h3 style="margin:0 0 4px;font-size:17px;font-weight:600;letter-spacing:-.01em">Entrega rápida indisponível agora</h3>'
      +       '<p style="margin:0;font-size:13px;color:#78716c;line-height:1.5">As modalidades rápidas (Mesmo Dia e Expressa) funcionam só em horários específicos.</p></div>'
      +   '</div>'
      +   '<div style="background:#FAFAF7;border:1px solid #E7E5E0;border-radius:8px;padding:12px 14px;margin-bottom:14px;font-size:13px;line-height:1.7">'
      +     '<div><strong>Mesmo Dia</strong> abre <span style="color:#2D5E1F;font-weight:600">' + escapeHtml(mdNext) + '</span></div>'
      +     '<div><strong>Expressa 3h</strong> abre <span style="color:#2D5E1F;font-weight:600">' + escapeHtml(exNext) + '</span></div>'
      +   '</div>'
      +   '<div style="font-size:13px;color:#44403c;line-height:1.5;margin-bottom:16px">'
      +     'Você pode <strong>finalizar com Entrega Agendada</strong> (próxima: ' + escapeHtml(nextDelivery) + ') ou voltar quando uma das janelas abrir.'
      +   '</div>'
      +   '<div style="display:flex;gap:8px;flex-wrap:wrap">'
      +     '<button id="rdtPopupAgendada" style="flex:1;min-width:140px;padding:10px 14px;border:0;border-radius:8px;background:#2D5E1F;color:#fff;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit">Usar Entrega Agendada</button>'
      +     '<button id="rdtPopupVolta" style="flex:1;min-width:120px;padding:10px 14px;border:1px solid #E7E5E0;border-radius:8px;background:#fff;color:#44403c;font-size:13px;font-weight:500;cursor:pointer;font-family:inherit">Volto depois</button>'
      +   '</div>'
      + '</div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    function close() {
      try { sessionStorage.setItem(POPUP_KEY, '1'); } catch(e){}
      overlay.remove();
      document.body.style.overflow = '';
    }
    overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
    overlay.querySelector('#rdtPopupAgendada').onclick = function() {
      // Troca catálogo pra A
      try { localStorage.setItem('rdt_catalog', 'A'); document.cookie = 'rdt_catalog=A; path=/; max-age=86400; samesite=lax'; } catch(e){}
      close();
      // Refresh a página pra reaplicar Cat A (UI/cart)
      setTimeout(function(){ window.location.reload(); }, 100);
    };
    overlay.querySelector('#rdtPopupVolta').onclick = close;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  // Cache da última resposta /lookup pra reaproveitar no popup
  var origLookup = lookup;
  lookup = function(cep) {
    return origLookup(cep).then(function(d) {
      if (d) window.__rdtLastLookup = d;
      return d;
    });
  };

  // Trigger popup em cart e checkout pages
  function maybeShowPopup() {
    var path = (window.location.pathname || '').toLowerCase();
    if (path === '/cart' || path.indexOf('/cart') === 0 || path.indexOf('/checkout') !== -1) {
      checkCatBWindowAndPopup();
    }
  }

  // Expõe pra debug e pra calls manuais (snippet Liquid também pode chamar)
  window.__rdtCepTier = {
    lookup: lookup,
    set: function(cep) { handleCepInput(cep); },
    last: function() { return lastCep; },
    refreshNow: refreshNowAttribute,
    checkCatBPopup: checkCatBWindowAndPopup,
  };

  // Refresh imediato no load — garante _rdt_now_iso atualizado
  // em toda visita a cart/checkout (independente de CEP digitado)
  function onReady() {
    refreshNowAttribute();
    maybeShowPopup();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
